<div class="defense" *ngIf="fieldSpots.length; else empty">
  <h3 class="defense__title">
    <span *ngIf="teamName" class="defense__team">{{ teamName }}</span>
    <span class="defense__title-label">Defense</span>
  </h3>
  <div class="defense__field-row" [class.defense__field-row--with-bench]="bench?.length">
  <svg class="defense__field" viewBox="-10 0 260 245" preserveAspectRatio="xMidYMid meet">
    <!-- Outfield grass -->
    <path class="defense__grass"
          d="M 120,193 L 210,103 A 90,90 0 0 0 30,103 L 120,193 Z"/>
    <!-- Foul lines -->
    <line class="defense__foul-line" x1="120" y1="193" x2="210" y2="103"/>
    <line class="defense__foul-line" x1="120" y1="193" x2="30" y2="103"/>
    <!-- Infield dirt -->
    <polygon class="defense__infield" points="120,183 173,130 120,80 67,130"/>
    <!-- Bases -->
    <rect class="defense__base" x="116" y="179" width="8" height="8" transform="rotate(45 120 183)"/>
    <rect class="defense__base" x="169" y="126" width="8" height="8" transform="rotate(45 173 130)"/>
    <rect class="defense__base" x="116" y="76" width="8" height="8" transform="rotate(45 120 80)"/>
    <rect class="defense__base" x="63" y="126" width="8" height="8" transform="rotate(45 67 130)"/>
    <!-- Pitcher's mound -->
    <circle class="defense__mound" cx="120" cy="138" r="10"/>

    <!-- Players -->
    <g *ngFor="let spot of fieldSpots">
      <circle class="defense__player-dot" [attr.cx]="spot.cx" [attr.cy]="spot.cy" r="8"/>
      <text class="defense__player-pos" [attr.x]="spot.cx" [attr.y]="spot.cy + 2.5"
            text-anchor="middle">{{ spot.positionLabel }}</text>
      <text class="defense__player-name"
            [attr.text-anchor]="spot.labelAnchor">
        <tspan [attr.x]="spot.labelX" [attr.y]="spot.labelY">
          <tspan *ngIf="spot.number" class="defense__player-num">{{ spot.number }}</tspan><tspan>{{ spot.number ? ' ' : '' }}{{ spot.surname }}</tspan>
        </tspan>
        <tspan *ngIf="spot.givenNames" [attr.x]="spot.labelX" dy="8.5">{{ spot.givenNames }}</tspan>
      </text>
    </g>
  </svg>

  <aside class="defense__bench" *ngIf="bench?.length">
    <h4 class="defense__bench-title">Bench ({{ bench.length }})</h4>
    <ul class="defense__bench-list">
      <li *ngFor="let p of bench" class="defense__bench-item">
        <span class="defense__bench-num">{{ p.number || '—' }}</span>
        <span class="defense__bench-name">{{ p.name }}</span>
      </li>
    </ul>
  </aside>
  </div>
</div>

<ng-template #empty>
  <div class="defense__empty">No defensive lineup data.</div>
</ng-template>
